import Link from "next/link";
import { STANDINGS_URL } from "../../../utils/constants/websiteUrls";
import RightArrowIcon from "../../common/icons/RightArrowIcon";

const StandingsButton = () => {
  return <>
    <div className="flex justify-center items-center mt-10">
      <Link
        href={STANDINGS_URL}
        className="text-sm font-semibold text-gray-900 sm:block">
        View standings<span aria-hidden="true">
          <RightArrowIcon />
        </span>

      </Link>
    </div>
  </>;
};

export default StandingsButton;
